export default "<h3>Security Settings</h3>\n<app-api-gateway-settings></app-api-gateway-settings>\n"